import React, { createContext, useContext, useState } from 'react';
import { DEMO_USER, DEMO_TRADES, DEMO_AI_INSIGHT } from '../data/demoData';

export const DemoContext = createContext(null);

export function DemoProvider({ children }) {
  const [isDemoMode, setIsDemoMode] = useState(false);

  const enterDemoMode = () => {
    setIsDemoMode(true);
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'demo_started', { event_category: 'demo' });
    }
  };

  const exitDemoMode = () => {
    setIsDemoMode(false);
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'demo_exited', { event_category: 'demo' });
    }
  };

  return (
    <DemoContext.Provider value={{
      isDemoMode,
      demoUser: DEMO_USER,
      demoTrades: DEMO_TRADES,
      demoInsight: DEMO_AI_INSIGHT,
      enterDemoMode,
      exitDemoMode,
    }}>
      {children}
    </DemoContext.Provider>
  );
}

export function useDemoMode() {
  return useContext(DemoContext);
}
